import { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import SmartGovernanceVerificationLogo from './_smartGovernanceVerificationLogo';
import { OrganisationAssignmentDto } from 'models/dtoTypes';
import Box from '@mui/material/Box';
import { GetSgAssignmentByKosmosCompany } from 'services/company';
import { CircularProgress } from '@mui/material';

const PREFIX = '_pageHeader';

const classes = {
  column: `${PREFIX}-column`,
  logoContainer: `${PREFIX}-logoContainer`,
};

const Root = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  display: 'flex',
  marginTop: 15,
  [`& .${classes.column}`]: {
    flex: 1,
  },

  [`& .${classes.logoContainer}`]: {
    '& > *': {
      marginLeft: 'auto',
    },
  },
}));

interface IProps {
  kosmosCompanyId: string;
  name: string;
  address: string;
  isSmartGovVerified: boolean;
}

export default function PageHeader(props: IProps): JSX.Element {
  const { name, address, kosmosCompanyId } = props;

  const [loading, setLoading] = useState(false);

  const [sgAssignment, setSgAssignment] = useState<OrganisationAssignmentDto>();

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        const sgAssignment = await GetSgAssignmentByKosmosCompany(kosmosCompanyId);
        setSgAssignment(sgAssignment);
      } catch (e) {
        console.error(e);
      }
      setLoading(false);
    };
    loadData();
  }, []);

  const handleSelectSgCompany = (id: string) => {
    window.open(`/combined-reports/${id}?type=sg`, '_blank');
    return;
  };

  const renderSgVerifiedIcon = () => {
    if (loading) {
      return (
        <div style={{ textAlign: 'right' }}>
          <CircularProgress />
        </div>
      );
    } else {
      return (
        <SmartGovernanceVerificationLogo
          kosmosCompanyId={kosmosCompanyId}
          smartGovernanceAssignment={sgAssignment}
          align="right"
          onClickCompleted={handleSelectSgCompany}
        />
      );
    }
  };

  return (
    <Root>
      <div className={classes.column}>
        <Typography variant="h5" gutterBottom color="secondary">
          {name}
        </Typography>
        <div style={{ marginTop: 5 }}>
          <Typography variant="body1" gutterBottom sx={{ m: 0, p: 0 }}>
            {address}
          </Typography>
        </div>
      </div>
      <Box className={classes.column}>
        <div className={classes.logoContainer}>{renderSgVerifiedIcon()}</div>
      </Box>
    </Root>
  );
}
